import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { XsI18nPipe } from '@nx-fe/pipes';

@Component({
  selector: 'ins-expired-session',
  templateUrl: './expired-session.component.html',
  styleUrls: ['./expired-session.component.scss'],
})
export class ExpiredSessionComponent implements OnInit {
  counter: number;

  constructor(
    @Inject('LOCALSTORAGE') private localStorage: Storage,
    private router: Router,
    private route: ActivatedRoute,
    private xsI18nPipe: XsI18nPipe,
    @Inject('Window') private window: Window
  ) {}

  ngOnInit() {
    this.counter = 5;
    const interval = setInterval(() => {
      this.counter = this.counter - 1;
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      this.redirectHandler();
    }, 5500);
  }

  redirectHandler() {
    this.localStorage.removeItem('ls.authorizationData');
    this.redirectToLogin();
  }

  private redirectToLogin(): void {
    let redirectUrl = this.route.snapshot.queryParams['redirectUrl'];
    while (redirectUrl !== decodeURI(redirectUrl)) {
      console.log('decoding redirectUrl', redirectUrl);
      redirectUrl = decodeURI(redirectUrl);
    }

    console.log('Redirecting to:', redirectUrl);
    this.window.location.href = redirectUrl;
  }

  getExpiredMessage() {
    return this.xsI18nPipe.transform('expired_session_message', this.counter);
  }
}
